import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../Context/AuthContext';
import useRequestHandler from '../useRequestHandler';

const useLoadCompanyPrivacyPolicy = () => {

    const { t } = useTranslation();
    const { acquireTokenSilently, apiClient } = useContext(AuthContext);
    const { errorHandler, successHandler } = useRequestHandler();

    /** Load company privacy policy
     * @param {object} privacyPolicy - object discribing file
     * @example
     * {
     *     "PrivacyPolicy": file
     * }
    */
    const loadCompanyPrivacyPolicy = async (privacyPolicy) => {
        try {

            const accessToken = await acquireTokenSilently();

            if (accessToken === "login_required") throw Error("login_required");

            const result = await apiClient.create(accessToken, "company/privacypolicy", privacyPolicy);

            return successHandler(result, "useLoadCompanyPrivacyPolicy", "create", { message: t('success.companyPrivacyPolicyCreatedSuccesfully') });

        } catch (error) {

            return errorHandler(error, "useLoadCompanyPrivacyPolicy", "create");

        }
    }

    return { loadCompanyPrivacyPolicy };

}

export default useLoadCompanyPrivacyPolicy;
